import viewport from './viewport';

export default {
  scroll(wrap, item, events) {
    var lastScrollTop = 0;
    $(window).on(events, function() {
      var st = $(this).scrollTop();
      var delay = 0;
      $(wrap).each(function(i, wrap){
        let targetItems = $(this).find(item);
        $(targetItems).each(function(i, prod){
          var prodTop = $(prod).offset().top + (parseFloat($(prod).css('height'))/3);
          var mark = window.pageYOffset + (window.innerHeight*8/9);

          if (mark > prodTop && st > lastScrollTop) {
            setTimeout(function(){ 
              $(prod).delay(delay).addClass('found'); 
            }, delay);
            delay += 250;
          }
        });
        delay = 0;
      });
    });
  },
  load(wrap, item) {
    $(window).on('load', function() {
      var delay = 0;
      $(wrap).each(function(i, wrap){
        let targetItems = $(this).find(item);
        $(targetItems).each(function(i, prod){
          if (viewport.init(item)) {
            setTimeout(function(){ 
              $(prod).delay(delay).addClass('found'); 
            }, delay);
            delay += 500;
          }
        });
        delay = 0;
      });
    });
  },
  title(item) {
    $(item).addClass('found');
  }
}
